import { html, View } from 'rune-ts';
import {
  MY_PAGE_MENU_MAP,
  MY_PAGE_TABS_MAP,
  type MyPageMenuOptions,
  type MyPageTabsOptionMap,
} from '../../constant';
import { MyPageMenu } from '../MyPageMenu/MyPageMenu';
import { MyPageTabs } from '../MyPageTabs/MyPageTabs';

interface MyPageBodyProps {
  my_page_tabs_option_map: Readonly<MyPageTabsOptionMap>;
  selected_tab: keyof typeof MY_PAGE_TABS_MAP;
  url: string;
  is_mobile: boolean;
}

export class MyPageBody extends View<MyPageBodyProps> {
  my_page_menu_option_list: MyPageMenuOptions;

  constructor(props: MyPageBodyProps) {
    super(props);

    this.my_page_menu_option_list = Object.values(MY_PAGE_MENU_MAP).map((option) => ({
      ...option,
      active: this.data.url.includes(option.href),
    }));
  }

  override template() {
    const { is_mobile } = this.data;

    return html`
      <div>
        ${is_mobile ? '' : new MyPageMenu({ menu: this.my_page_menu_option_list })}
        ${new MyPageTabs({
          tabs_map: this.data.my_page_tabs_option_map,
        })}
      </div>
    `;
  }
}
